import axios from "../../utilities/axios";
import parseHeadersLink from "../../utilities/parseHeadersLink";

export const getVideos = async (tags, search, author, page, limit) => {
  let queryString = "";
  if (tags.length > 0) {
    queryString += "tags_like=" + tags.join("&tags_like=");
  }
  if (search !== "") {
    queryString += `&q=${search}`;
  }
  if (author !== "") {
    queryString += `&author=${author}`;
  }
  const response = await axios.get(`/videos?${queryString}&_page=${page}&_limit=${limit}`);
  const lastPage = parseHeadersLink(response.headers?.link);
  return { data: response.data, lastPage };
};
